var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { get, forIn, forEach } from 'lodash';
import { getStore } from '../../store';
import * as actions from '../../actions';
/**
 * 实体
 */

var Entity = function () {
  function Entity(params) {
    // 存储路由参数
    this.params = params;
  }
  /**
   * 初始化实体属性的元信息
   * @param propertyName - 属性名
   * @param propertyDefination - 属性定义
   * @param properties - 实体所有属性定义
   */


  Entity.prototype.initPropertyMeta = function (propertyName, propertyDefination, properties) {
    var _this = this;

    if (properties === void 0) {
      properties = {};
    }

    var options = propertyDefination.options,
        source = propertyDefination.source;

    if (options && source) {
      if (source.dependences) {
        forEach(source.dependences, function (dependence) {
          var property = Entity.getPropertyByPath(dependence, properties);

          if (!property) {
            throw new Error("Dependence " + dependence + " required by " + propertyName + " not found.");
          }

          if (!property.triggerOptionsReload) {
            property.triggerOptionsReload = [];
          }

          property.triggerOptionsReload.push(propertyName);
        });
      }

      if (source.loadOnInit !== false) {
        this.loadPropertyOptions(propertyName, source, this.params);
      }
    } // 处理子属性


    forIn(propertyDefination.properties, function (subProperty, subPropertyName) {
      _this.initPropertyMeta(propertyName + "." + subPropertyName, subProperty, properties);
    });
  };
  /**
   * 更新实体的元信息定义
   * @param changedMeta - 发生改变的实体的元信息定义
   */


  Entity.prototype.setMeta = function (changedMeta) {
    var meta = Object.assign({}, this.metainfo, changedMeta);
    getStore().dispatch(actions.setEntityMetaAction(this, meta));
  };
  /**
   * 更新筛选器信息
   * @param changedFilters - 发生改变的筛选器信息
   */


  Entity.prototype.filtersChange = function (changedFilters) {
    var filters = Object.assign({}, this.filters, changedFilters);
    getStore().dispatch(actions.filtersChangeAction(this, filters));
  };
  /**
   * 更新分页信息
   * @param changedPageInfo - 发生改变的分页信息
   */


  Entity.prototype.pageChange = function (changedPageInfo) {
    var paging = Object.assign({}, this.paging, changedPageInfo);
    getStore().dispatch(actions.pageChangeAction(this, paging));
  };
  /**
   * 查询
   * @param params - 路由参数
   * @param successBehavior - 查询成功后的行为
   * @param errorBehavior - 查询失败后的行为
   */


  Entity.prototype.search = function (params, successBehavior, errorBehavior) {
    getStore().dispatch(actions.searchAction(this, __assign(__assign({}, this.params), params), successBehavior, errorBehavior));
  };
  /**
   * 加载下一页数据
   * @param params - 路由参数
   * @param successBehavior - 加载成功后的行为
   * @param errorBehavior - 加载失败后的行为
   */


  Entity.prototype.loadNextPage = function (params, successBehavior, errorBehavior) {
    getStore().dispatch(actions.loadNextPageAction(this, __assign(__assign({}, this.params), params), successBehavior, errorBehavior));
  };
  /**
   * 添加新资源
   * @param fields - 新资源属性信息
   * @param params - 路由参数
   * @param successBehavior - 添加成功后的行为
   * @param errorBehavior - 添加失败后的行为
   */


  Entity.prototype.add = function (fields, params, successBehavior, errorBehavior) {
    getStore().dispatch(actions.addAction(this, fields, __assign(__assign({}, this.params), params), successBehavior, errorBehavior));
  };
  /**
   * 删除目标资源
   * @param params - 路由参数
   * @param successBehavior - 删除成功后的行为
   * @param errorBehavior - 删除失败后的行为
   */


  Entity.prototype.delete = function (params, successBehavior, errorBehavior) {
    getStore().dispatch(actions.deleteAction(this, __assign(__assign({}, this.params), params), successBehavior, errorBehavior));
  };
  /**
   * 获取目标资源信息
   * @param params - 路由参数
   * @param successBehavior - 获取成功后的行为
   * @param errorBehavior - 获取失败后的行为
   */


  Entity.prototype.get = function (params, successBehavior, errorBehavior) {
    getStore().dispatch(actions.getAction(this, __assign(__assign({}, this.params), params), successBehavior, errorBehavior));
  };
  /**
   * 修改目标资源的信息
   * @param fields - 修改后的资源属性信息
   * @param params - 路由参数
   * @param successBehavior - 修改成功后的行为
   * @param errorBehavior - 修改失败后的行为
   */


  Entity.prototype.modify = function (fields, params, successBehavior, errorBehavior) {
    getStore().dispatch(actions.modifyAction(this, fields, __assign(__assign({}, this.params), params), successBehavior, errorBehavior));
  };
  /**
   * 获取属性候选项
   * @param path - 属性路径
   * @param source - 远程资源定义
   * @param params - 路由参数
   * */


  Entity.prototype.loadPropertyOptions = function (path, source, params) {
    var apiRoot = source.apiRoot,
        apiPath = source.apiPath,
        paramsFilter = source.paramsFilter;
    var data = {
      apiRoot: apiRoot,
      apiPath: apiPath,
      paramsFilter: paramsFilter,
      params: __assign(__assign({}, this.params), params)
    };
    getStore().dispatch(actions.loadPropertyOptionsAction(this, path, data));
  };
  /**
   * 获取筛选器候选项
   * @param path - 筛选属性路径
   * @param source - 远程资源定义
   * @param params - 路由参数
   * */


  Entity.prototype.loadFilterOptions = function (path, source, params) {
    var apiRoot = source.apiRoot,
        apiPath = source.apiPath,
        paramsFilter = source.paramsFilter;
    var data = {
      apiRoot: apiRoot,
      apiPath: apiPath,
      paramsFilter: paramsFilter,
      params: __assign(__assign({}, this.params), params)
    };
    getStore().dispatch(actions.loadFilterOptionsAction(this, path, data));
  };
  /**
   * 设置资源信息
   * @param fields - 资源信息
   * */


  Entity.prototype.setFields = function (fields) {
    getStore().dispatch(actions.setEntityFieldsAction(this, fields));
  };
  /** 销毁实体 */


  Entity.prototype.unmount = function () {
    getStore().dispatch(actions.unmountEntityAction(this));
  };
  /**
   * 从 Recux 仓库中获取指定的实体数据。
   * @return 实体数据集
   */


  Entity.prototype.getEntityDataFromStore = function () {
    var state = getStore().getState();
    return get(state, "entities[" + this.id + "]", {});
  };

  Object.defineProperty(Entity.prototype, "metainfo", {
    /** 获取元信息 */
    get: function get() {
      var entityData = this.getEntityDataFromStore();
      return entityData.metainfo;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Entity.prototype, "filters", {
    /** 获取筛选器属性信息 */
    get: function get() {
      var entityData = this.getEntityDataFromStore();
      return entityData.filters;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Entity.prototype, "paging", {
    /** 获取分页信息 */
    get: function get() {
      return this.getEntityDataFromStore().paging;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Entity.prototype, "result", {
    /** 获取查询结果 */
    get: function get() {
      return this.getEntityDataFromStore().result;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Entity.prototype, "fields", {
    /** 获取表单信息 */
    get: function get() {
      return this.getEntityDataFromStore().fields;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Entity.prototype, "created", {
    /** 获取新创建资源的信息 */
    get: function get() {
      return this.getEntityDataFromStore().created;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Entity.prototype, "requestStatus", {
    /** 获取请求状态 */
    get: function get() {
      return this.getEntityDataFromStore().requestStatus;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Entity.prototype, "isLoading", {
    /** 是否正在进行请求 */
    get: function get() {
      return this.requestStatus === 'pending';
    },
    enumerable: true,
    configurable: true
  });
  /**
   * 根据属性路径获取实体属性
   * @param path 属性路径
   * @param properties 顶级属性属性定义
   * @returns 实体属性
   */

  Entity.getPropertyByPath = function (path, properties) {
    path = path.split('.').join('.properties.');
    return get(properties, path);
  };

  return Entity;
}();

export { Entity };